import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TabView, { Tab } from '../../../components/TabView';
import Strings from '../../../Strings';
import MessageNew from './MessageNew';
import { hasPermission, PERMISSIONS } from '../../../utils/userPermissions';
import PrefabReplies from './PrefabReplies';
import DefaultMessages from '../../Organizations/Configuration/DefaultMessages';
import MessageList, { Tabs } from './MessageList';
import { PageHeader } from '../../../components/PageHeader';
import OrgSelect from '../../../components/OrgSelect/OrgSelect';

class Messages extends PureComponent {
  searchTime;

  static propTypes = { activeTab: PropTypes.string.isRequired };

  render() {
    const { activeTab } = this.props;
    const tabArray = [];
    const messageInbox = (
      <Tab key="inbox" name={Strings.messages.inbox} path="/messages/inbox">
        <MessageList tab={Tabs.INBOX} />
      </Tab>
    );

    const archived = (
      <Tab key="archived" name={Strings.messages.archived} path="/messages/archived">
        <MessageList tab={Tabs.ARCHIVED} />
      </Tab>
    );

    const newMessage = (
      <Tab key="new" name={Strings.messages.new} path="/messages/new">
        <MessageNew></MessageNew>
      </Tab>
    );

    const prefabReplies = (
      <Tab key="new" name={Strings.messages.prefabReplies} path="/messages/prefabs">
        <PrefabReplies />
      </Tab>
    );

    const defaultReminders = (
      <Tab key="default-reminders" name={Strings.defaultReminders} path="/messages/default-reminders">
        <DefaultMessages organizationId={this.props.userOrgId} />
      </Tab>
    )

    if (hasPermission(PERMISSIONS.MESSAGES_INBOX)) {
      tabArray.push(messageInbox);
    }
    if (hasPermission(PERMISSIONS.MESSAGES_ARCHIVED)) {
      tabArray.push(archived);
    }
    if (hasPermission(PERMISSIONS.MESSAGES_SEND_MESSAGES)) {
      tabArray.push(newMessage);
    }
    if (hasPermission(PERMISSIONS.MESSAGES_PREFABS)) {
      tabArray.push(prefabReplies);
    }
    if (hasPermission(PERMISSIONS.MESSAGES_DEFAULT_REMINDERS_VIEW)) {
      tabArray.push(defaultReminders);
    }

    return (
      <>
        <PageHeader left={Strings.messages.messages} right={activeTab === "Inbox" || activeTab === "Archived" ? <OrgSelect /> : null} />
        <TabView key="tabs" activeTab={activeTab} routeMode className="" noSwiping>
          {tabArray}
        </TabView>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    userOrgId: state.auth.profile?.organization?.masked_id,
  };
};

export default connect(mapStateToProps, null)(Messages);
